<template>
  <circular-icon-button
    icon-name="mira"
    :icon-size="16"
    :show-notification="showNotification"
    :active="active"
    @click="launchMira"
  />
</template>

<script>
import CircularIconButton from '@/components/ui/CircularIconButton';

export default {
  name: 'MiraButton',
  components: {
    CircularIconButton,
  },
  props: {
    contextType: {
      type: String,
      default: null,
    },
    assetId: {
      type: Number,
      default: null,
    },
    assetType: {
      type: String,
      default: null,
    },
    showNotification: {
      type: Boolean,
      default: false,
    },
    active: {
      type: Boolean,
      default: false,
    },
  },
  methods: {
    launchMira() {
      if (this.active) {
        return;
      }
      const shown = this.$store.getters['ui/miraDrawerShown'];
      this.$store.dispatch('mira/setContextType', this.contextType);
      this.$store.dispatch('mira/setAssetId', this.assetId);
      this.$store.dispatch('mira/setAssetType', this.assetType);
      this.$store.dispatch('ui/setMiraDrawerShown', !shown);
    },
  },
};
</script>
